<template>
  <div class="text-center padding">
    <div v-if="!submited">
      <h2
        v-if="slide.title"
        class="mt-0 text-left slide-title-style"
        v-html="dataValue"
      />
      <p v-if="slide.titleDesc" class="mb-3 text-left slide-title-style title-desc">
        {{ slide.titleDesc }}
      </p>
      <div
        v-if="!slide.title && !slide.titleDesc"
        class="text-center no-data"
      >
        {{ $t("blankSlide") }}
      </div>
      <div
        v-if="slide.audioLink && slide.audioPlayOnAudience && slide.id"
        class="audio-control-slide"
      >
        <AudioControl />
      </div>

      <ProgressBarTimer />

      <div v-if="slide.image" class="slide-img-wrapper">
        <Loading v-if="isLoading" />
        <img
          v-else
          ref="slide-imgg"
          :src="slide.image.large"
          alt
          class="slide-img"
          @load="_imgLoaded"
        >
      </div>
      <form @submit.prevent="submit">
        <div class="list-input">
          <div v-for="(item, index) in items" :key="index">
            <div class="item-input" :class="{error: (25 - item.title.length) < 0 || item.error}">
              <input
                v-model="item.title"
                type="text"
                :placeholder="$t('enterWordPlaceholder')"
                maxlength="25"
                class="item-input-text"
                @input="validateInput(item)"
              >
              <div class="item-input-limit">
                {{ 25 - item.title.length }}
              </div>
            </div>

            <div
              v-if="item.error"
              class="text-danger"
              :class="{'white-text': $store.state.slide.textColour == '#ffffff'}"
            >
              {{ item.error }}
            </div>
          </div>
        </div>

        <div
          v-if="$store.state.slide.openEndedMultipleOption && !isFirstTimeSubmit"
          class="label"
        >
          {{ $t("submitMultipleTimes") }}
        </div>

        <div v-if="isFirstTimeSubmit && !submited" class="submited">
          {{ $t("open-endedInstructionSubmission") }}
        </div>

        <ui-button
          block
          size="lg"
          class="mb-3"
          type="submit"
          :disabled="submiting || $store.state.slide.stopSubmission"
        >
          <template v-if="!$store.state.slide.stopSubmission">
            <span>
              {{ $t("submit") }}
              <CountDownTimer />
            </span>

            <i v-if="!submiting" class="fas fa-check" />
            <ui-spinner v-else />
          </template>

          <template v-if="$store.state.slide.stopSubmission">
            <span>{{ $t("submissionClosedButton") }}</span>
            <i class="fa fa-lock" />
          </template>
        </ui-button>

        <ui-button
          v-show="isFirstTimeSubmit && !submited && !$store.state.presentation.audiencePacing"
          block
          size="lg"
          class="mb-3"
          variant="outline-primary"
          :disabled="checkNextSlide"
          @click="nextQuestion"
        >
          <span>{{ $t("nextSlideButton") }}</span>
          <ui-spinner v-if="checkNextSlide" color="black" />
        </ui-button>

        <div
          v-if="$store.state.slide.stopSubmission"
          class="stop-submission"
        >
          {{ $t("stopSubmission") }}
        </div>

        <div v-if="errorText" class="mb-3 text-center text-danger">
          {{ errorText }}
        </div>
      </form>
    </div>

    <SlideWaiting v-if="submited" />
  </div>
</template>
<script>
import { setTimeout } from 'timers'
import * as Sentry from '@sentry/vue'
import { mapState } from 'vuex'
import Config from '@/config'
import Util from '@/util'
import EvenBus from '@/eventBus'
import SlideWaiting from '@/components/SlideWaiting'
import Loading from '@/components/Loading'
import AudioControl from '@/components/AudioControl.vue'
import ProgressBarTimer from '@/components/ProgressBarTimer'
import CountDownTimer from '@/components/CountDownTimer'
import storage from '@/services/storage'

// UI
import UiButton from '@/components/UI/Button'
import UiSpinner from '@/components/UI/Spinner'
import ClickableTitleMixin from '@/mixins/ClickableTitleMixin'
import UserIsTypingMixin from '@/mixins/UserIsTypingMixin'

const WORLD_CLOUD_SUBMIT = 'Word Cloud Submit'

export default {
  components: {
    UiButton,
    UiSpinner,
    SlideWaiting,
    Loading,
    AudioControl,
    ProgressBarTimer,
    CountDownTimer,
  },
  mixins: [ClickableTitleMixin, UserIsTypingMixin],
  data() {
    return {
      items: [],
      submiting: false,
      submited: false,
      isFirstTimeSubmit: false,
      checkNextSlide: false,
      errorText: '',
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
      slide: (state) => state.slide,
    }),
  },
  watch: {
    '$store.state.slide': function _() {
      this.getArrInput()
      setTimeout(() => {
        if (this.$refs['slide-imgg'] && !this.$refs['slide-imgg'].complete) {
          this.isLoading = true
        }
      }, 1)
    },
  },
  mounted() {
    const index = this.$store.state.slide.SlideOptions.findIndex((item) => {
      return item.audience == this.audienceId
    })
    if (!this.$store.state.slide.openEndedMultipleOption && index != -1) {
      this.$store.state.slide.openEndedSubmited = true
      this.submited = true
    }
    this.getArrInput()
    this.checkSubmited()
  },
  methods: {
    checkSubmited() {
      const slideId = this.$store.state.slide.id
      const presentationId = this.$store.state.presentation.id
      const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
      const lastSlideId = this.$store.state.presentation.lastSlide
      if (answeredSlideIds.includes(slideId)) {
        if (lastSlideId === slideId &&
         !this.$store.state.slide.openEndedMultipleOption) {
          this.$store.state.slide.isEndSlide = true
        }
        this.$store.dispatch('updateSlide', this.$store.state.slide)
      }
    },
    validateInput(item) {
      this.setUserTypingStart() // UserIsTypingMixin
      const regex = /[!@#$%^&*(),.?":{}|<>]/
      if (regex.test(item.title)) {
        item.error = this.$t('addSpecialCharacter')
      } else {
        item.error = ''

        const text = item.title
        let check = false

        this.items.forEach((element) => {
          if (element.title) {
            check = true
          }
        })

        if (!text.replace(/\s/g, '') && !check) {
          item.error = this.$t('answerWithSpace')
        } else {
          item.error = ''
        }
      }

      this.items.push()
    },
    _checkAddData() {
      let check = false
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].title.trim()) {
          if (this.items[i].title.length > 25 || this.items[i].error) {
            return false
          }
          check = true
        }
      }

      if (!check) {
        if (this.items.length) {
          this.items[0].error = this.$t('errorWordCloudWhenLeaveBlank')
          this.items.push()
        }
        return false
      }
      return true
    },

    async submit() {
      if (!this._checkAddData()) {
        return
      }
      this.submiting = true
      const arr = this.items.filter((item) => {
        if (!item.title) return false

        item.title = item.title.trim()

        return item.title
      })

      this.errorText = ''
      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      // eslint-disable-next-line promise/catch-or-return
      this.$http
        .post(Config.api.createWordCloud, {
          slideId: this.$store.state.slide.id,
          items: arr,
          presentationId: this.$store.state.presentation.id,
          audience: this.audienceId,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
        })
        .then(
          () => {
            this.items.map((item) => {
              item.title = ''
              return item
            })
            this.submiting = false
            this.isFirstTimeSubmit = true
            if (!this.$store.state.slide.openEndedMultipleOption) {
              this.submited = true
              this.$store.state.slide.openEndedSubmited = true
              if (this.$store.state.presentation.lastSlide == this.$store.state.slide.id) {
                this.$store.state.slide.isEndSlide = true
              }
              this.$store.dispatch('updateSlide', this.$store.state.slide)
            }

            Util.gaTrackEvent(
              WORLD_CLOUD_SUBMIT,
              'Audience submited',
              'Audience submited',
            )

            const presentationId = this.$store.state.presentation.id
            const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
            answeredSlideIds.push(this.$store.state.slide.id)
            storage.setValueByPresentation(presentationId, 'answeredSlideIds', answeredSlideIds)

            // eslint-disable-next-line promise/always-return
            if (this.$store.state.presentation.audiencePacing &&
            !this.$store.state.slide.openEndedMultipleOption) {
              EvenBus.$emit('skipSlide')
            } else {
              EvenBus.$emit('confirmNextSlide')
            }
          },
          (err) => {
            this.submiting = false
            if (err.body && err.body.message) {
              this.errorText = err.body.message

              Util.gaTrackEvent(
                WORLD_CLOUD_SUBMIT,
                'Audience submit fail',
                err.body.message,
              )
            } else {
              this.errorText =
                'Submission unsuccessful. Please check your connection and try again.'
              Util.gaTrackEvent(
                WORLD_CLOUD_SUBMIT,
                'Audience submit fail',
                JSON.stringify(err),
              )
            }
          },
        )
        .finally(() => {
          this.setUserTypingEnd()
        })
    },

    getArrInput() {
      const arr = []

      for (let i = 0; i < this.$store.state.slide.entriesPerParticipant; i++) {
        arr.push({
          title: '',
        })
      }
      if (this.items.length != arr.length) {
        this.items = arr
      }
    },

    async nextQuestion() {
      if (this.$store.state.presentation.audiencePacing) {
        EvenBus.$emit('skipSlide')
        return
      }
      this.checkNextSlide = true
      this.$store.state.slide.openEndedSubmited = true
      this.$store.state.slide.openEndedMultipleOption = false

      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      this.$http
        .get(
          Config.api.getPresentation +
            this.$store.state.presentation.uniqueAccessCode,
          {
            params: {
              audience: this.audienceId,
              continue: true,
            },
          },
        )
        .then((res) => {
          this.checkNextSlide = false
          res.body = Util.formatSlide(res.body)
          Util.gaTrackEvent(
            WORLD_CLOUD_SUBMIT,
            'Audience Submit',
            'Audience choose Next Slide',
          )
          // eslint-disable-next-line promise/always-return
          if (res.body.id != this.$store.state.slide.id) {
            this.$store.dispatch('setSlide', res.body)
            EvenBus.$emit('hidePopupNextSlide')
            this.isFirstTimeSubmit = false
            this.submited = false
          } else {
            this.submited = true
            if (this.$store.state.presentation.lastSlide === this.$store.state.slide.id) {
              this.$store.state.slide.isEndSlide = true
              this.$store.dispatch('updateSlide', this.$store.state.slide)
            }
          }
        })
        .catch(Sentry.captureException)
    },

    _imgLoaded() {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.audio-control-slide {
  margin-bottom: 16px;
}
.button-submit {
  margin-bottom: 3px;
}

.no-data {
  margin-bottom: 16px;
}
.padding {
  padding: 0 16px;
}

.list-input {
  .text-danger {
    text-align: left;
    margin-bottom: 16px;
    font-size: 13px;
    &.white-text {
      color: #ffc3c3;
    }
  }

  .item-input {
    position: relative;
    margin-bottom: 16px;
  }
}

.label,
.submited {
  text-align: center;
  color: inherit;
  margin-bottom: 16px;
  opacity: 0.7;
}

.slide-img-wrapper {
  width: auto;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 0.83em;
  display: flex;
  flex-direction: row;
  align-items: center;

  & ::v-deep {
    .spinner {
      width: 120px;
      margin: 0 auto;
    }
    .spinner > div {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
}
</style>
